import { CheckoutState } from '../../state';
import { areAsyncExpressGooglePayEligibleRulesMet } from './areAsyncExpressGooglePayEligibleRulesMet';
import { areSyncExpressGooglePayEligibleRulesMet } from './areSyncExpressGooglePayEligibleRulesMet';

export const isExpressGooglePayEnabled = (state: CheckoutState) =>
    areSyncExpressGooglePayEligibleRulesMet(state) &&
    areAsyncExpressGooglePayEligibleRulesMet(state);
